const SET_LOADER = 'SET_LOADER'
const SET_LOGIN_DETAILS = 'SET_LOGIN_DETAILS'
const SET_FILTER_ITEMS = 'SET_FILTER_ITEMS'
const SET_COUNTRIES = 'SET_COUNTRIES'
const SET_PARTNER_DETAILS = 'SET_PARTNER_DETAILS'
const SET_LOGISTICS_DETAILS = 'SET_LOGISTICS_DETAILS'
const SET_OFFER_FILTER_ITEMS = 'SET_OFFER_FILTER_ITEMS'
const SET_USER_COUNTRY = 'SET_USER_COUNTRY'
const SET_PARTNER_LIST = 'SET_PARTNER_LIST'
const SET_PRODUCT_SUBCATEGORY_LIST = 'SET_PRODUCT_SUBCATEGORY_LIST'
const SET_PARTNER_FILTER_ITEM = 'SET_PARTNER_FILTER_ITEM'
const SET_LIQUIDATOR_LIST = 'SET_LIQUIDATOR_LIST'
const SET_LIQUIDATOR_DETAILS = 'SET_LIQUIDATOR_DETAILS'
const SET_LIQUIDATOR_FILTER_DETAILS = 'SET_LIQUIDATOR_FILTER_DETAILS'
const SET_USER_RIGHTS = 'SET_USER_RIGHTS'
const SET_DEPRECIATION_SELECTED_ITEM = 'SET_DEPRECIATION_SELECTED_ITEM'
const SET_DEPRECIATION_FILTER_DETAILS = 'SET_DEPRECIATION_FILTER_DETAILS'
const SET_GRADING_FILTER_DETAILS = 'SET_GRADING_FILTER_DETAILS'
const SET_GRADING_SELECTED_ITEM = 'SET_GRADING_SELECTED_ITEM'
const SET_PRODUCTS_LIST = 'SET_PRODUCTS_LIST'
const SET_BRAND_LIST = 'SET_BRAND_LIST'
const SET_GRADE_DEPRECIATION_FILTER_ITEM = 'SET_GRADE_DEPRECIATION_FILTER_ITEM'
const SET_GRADE_DEPRECIATION_SELECTED_ITEM = 'SET_GRADE_DEPRECIATION_SELECTED_ITEM'
const SET_PARTNER = 'SET_PARTNER'
const SET_OFFER_EDIT_ITEM = 'SET_OFFER_EDIT_ITEM'
const SET_DEACTIVATE_OFFER_REQUEST = 'SET_DEACTIVATE_OFFER_REQUEST'
const SET_TRADEIN_DETAILS = 'SET_TRADEIN_DETAILS'
const SET_OFFERS_LIST = 'SET_OFFERS_LIST'
const SET_OFFER_CONFIGURATION_ITEM = 'SET_OFFER_CONFIGURATION_ITEM'
const SET_DASHBOARD_ERROR = 'SET_DASHBOARD_ERROR'
const SET_RESET_DATA = 'SET_RESET_DATA'
const SET_ROLE = 'SET_ROLE'
const SET_DASHBOARD_RIGHTS = 'SET_DASHBOARD_RIGHTS'
const SET_BULK_DETAILS = 'SET_BULK_DETAILS'
const SET_PAYMENT_MODEL = 'SET_PAYMENT_MODEL'
const SET_LANGUAGE = 'SET_LANGUAGE'
const SET_LIQUIDATOR_FLAG = 'SET_LIQUIDATOR_FLAG'
const SET_TRADEIN_PARTNERS_LIST = 'SET_TRADEIN_PARTNERS_LIST'
const SET_ASSIGNED_PARTNER = 'SET_ASSIGNED_PARTNER'
const SET_DASHBOARD_DETAILS_KEYS = 'SET_DASHBOARD_DETAILS_KEYS'
const SET_PARTNER_SERVICE_LOCATION_ID = 'SET_PARTNER_SERVICE_LOCATION_ID'
const SET_PAYTM_LINK_WALLET = 'SET_PAYTM_LINK_WALLET'
const sel_lang_code = localStorage.getItem('language');
const SET_TOKEN_EXPIRYTIME ="SET_TOKEN_EXPIRYTIME"
const SET_DEACTIVATE_DAIGNOSTICS_REQUEST ="SET_DEACTIVATE_DAIGNOSTICS_REQUEST"
const SET_DAIGNOSTIC_DETAILS ="SET_DAIGNOSTIC_DETAILS"
const SET_DAIGNOSTIC_FILTER ="SET_DAIGNOSTIC_FILTER"

const SET_PROMO_DETAILS = 'SET_PROMO_DETAILS'
const SET_PROMO_FILTER_ITEMS = 'SET_PROMO_FILTER_ITEMS'
const SET_TACCODE_FILTER_ITEMS = 'SET_TACCODE_FILTER_ITEMS'
const SET_PROGRAM_OFFER_DETAILS ="SET_PROGRAM_OFFER_DETAILS"
const SET_PROGRAM_OFFER_FILTER_ITEMS ="SET_PROGRAM_OFFER_FILTER_ITEMS"
const SET_PROGRAM_LOCATION_FILTER_ITEMS = 'SET_PROGRAM_LOCATION_FILTER_ITEMS'
const SET_DEACTIVATE_PROGRAM_LOCATION_REQUEST = 'SET_DEACTIVATE_PROGRAM_LOCATION_REQUEST'
const SET_DEACTIVATE_OFFER_MARGIN_REQUEST = 'SET_DEACTIVATE_OFFER_MARGIN_REQUEST'
const SET_OFFER_MARGIN_FILTER_ITEMS = 'SET_OFFER_MARGIN_FILTER_ITEMS'
const SET_OFFER_CREATION_DETAILS = 'SET_OFFER_CREATION_DETAILS'
const SET_OFFER_CREATION_RANGE = 'SET_OFFER_CREATION_RANGE'
const SET_OFFER_CREATION_MARGIN = 'SET_OFFER_CREATION_MARGIN'
const SET_OFFER_CREATION_PROGRAM_MAPPING = 'SET_OFFER_CREATION_PROGRAM_MAPPING'
const SET_OFFER_CREATION_BRAND_MAPPING = 'SET_OFFER_CREATION_BRAND_MAPPING'
const SET_OFFER_CREATION_REVIEW_FLAG = 'SET_OFFER_CREATION_REVIEW_FLAG'
const SET_OFFER_CREATION_RANGE_TYPE = 'SET_OFFER_CREATION_RANGE_TYPE'

export const setLoader = (payload) => ({
  type: SET_LOADER,
  payload,
})
export const setProductSubcategoryList = (payload) => ({
  type: SET_PRODUCT_SUBCATEGORY_LIST,
  payload,
})

export const setBrandsList = (payload) => ({
  type: SET_BRAND_LIST,
  payload,
})

export const setProductsList = (payload) => ({
  type: SET_PRODUCTS_LIST,
  payload,
})


export const setPatner = (payload) => ({
  type: SET_PARTNER,
  payload,
})


export const setOffersList = (payload) => ({
  type: SET_OFFERS_LIST,
  payload,
})


export const setDashboardError = (payload) => ({
  type: SET_DASHBOARD_ERROR,
  payload,
})

export const setSelectedLanguage = (payload) => ({
 type: SET_LANGUAGE,
 payload,
})


const initialState = {
  showLoader: false,
  brandsList: [],
  productsList: [],
}

const common = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADER:
      return { ...state, showLoader: action.payload}
    case SET_COUNTRIES:
      return { ...state, countries: action.payload}
    case SET_BRAND_LIST:
      return { ...state, brandsList: action.payload}
    case SET_PRODUCTS_LIST:
      return { ...state, productsList: action.payload}
    default:
      return state
  }
}

export default common